import { Chip } from "@mui/material";
import { useRecordContext } from "react-admin";
import type { ProviderStatus } from "../../../types/api";

export const ProviderStatusChip = () => {
  const record = useRecordContext();
  if (!record) return null;

  const status = record.status as ProviderStatus;

  const getStatusColor = (status: ProviderStatus) => {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "default";
      case "maintenance":
        return "warning";
      case "deprecated":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusLabel = (status: ProviderStatus) => {
    return status.charAt(0).toUpperCase() + status.slice(1);
  };

  return (
    <Chip
      label={getStatusLabel(status)}
      color={getStatusColor(status)}
      size="small"
    />
  );
};
